<!--
 * @Descripttion: 申请样品业务组件，支持快速申样及批量申样
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-10-10 14:15:33
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2023-03-29 10:24:26
-->
<template>
	<div class="flex-row fz-14" v-loading="createLoading">
		<div class="color-gy-8 mr-16 text-align-right" style="width:60px">{{ info.label }}</div>
		<div class="flex-1">
			<el-button type="primary" @click="show">添加员工</el-button>
			<div class="mt-16">
				<span class="mr-12">已选 {{ tagtList.length }}/{{ info.content.receiver_limit }} 个</span>
				<el-tag v-for="tag in tagtList" :key="tag.nickname" size="medium" closable class="mr-12 mb-6" effect="plain" @close="handleCloseTag(tag)">
					{{ tag.nickname | textFormat(4) }}
				</el-tag>
			</div>
		</div>
		<el-drawer
			:append-to-body="true"
			title="添加员工"
			:visible.sync="visible"
			class="add-staff"
			:before-close="handleClose"
			size="480px"
			:wrapperClosable="false"
			destroy-on-close
		>
			<!-- 抽屉内容 -->
			<div class="content">
				<div class="flex-row flex-align-center">
					<el-form class="pos-rela ml-12 flex-1" @submit.native.prevent="search">
						<el-input placeholder="请输入员工名称" v-model="form.userName" clearable></el-input>
						<el-button class="searchBtn" @click="search">搜索</el-button>
					</el-form>
				</div>
				<el-table
					class="mt-24"
					:data="list"
					@selection-change="handleSelectionChange"
					header-row-class-name="table-header-row"
					row-class-name="table-row"
					ref="table"
					v-loading="tableLoading"
					row-key="id"
				>
					<el-table-column :selectable="selectable" type="selection" width="55"></el-table-column>
					<el-table-column label="员工名称">
						<template slot-scope="{ row }">
							<div class="flex-row">
								<p>{{ row.nickname | textFormat(10) }}</p>
								<Tag v-if="row.status == 1" class="ml-8" content="已停用" type="danger"></Tag>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="手机号" width="150">
						<template slot-scope="{ row }">
							<div>
								{{ row.mobile }}
							</div>
						</template>
					</el-table-column>
					<template slot="empty">
						<Empty />
					</template>
				</el-table>
			</div>
			<!-- 底部按钮组 -->
			<div class="footer yx-background-white">
				<el-button @click="handleClose">取消</el-button>
				<el-button type="primary" @click="confirm" :disabled="isDisable" :loading="btnLoading">确认添加</el-button>
			</div>
		</el-drawer>
	</div>
</template>
<script>
import Tag from '@/components/ui/tag';
import { mangerUserList3 } from '@/api/common';
import { uniqBy } from 'lodash';
import Empty from '@/views/common/empty/index.vue';
export default {
	name: 'AppleSampleDrawer',
	props: {
		info: {
			type: Object,
			default: () => {
				return {};
			},
		},
	},
	components: {
		Tag,
		Empty,
	},
	data() {
		return {
			visible: false, // 抽屉显隐
			btnLoading: false,
			form: {
				userName: '',
			},
			list: [],
			tableLoading: false,
			createLoading: false,
			selectList: [],
			selectListTem: [],
			tagtList: [],
		};
	},
	computed: {
		isDisable({ selectList }) {
			return !selectList.length;
		},
	},
	async created() {
		this.createLoading = true;
		await this.loadList();
		this.createLoading = false;
		this.initList = this.list;
		this.tagtList = this.initList.filter(item => {
			return this.info.content.select_value.includes(item.id);
		});
	},
	methods: {
		show() {
			this.selectListTem = this.tagtList;
			this.list = this.initList;
			this.form.userName = '';
			this.visible = true;
			this.$nextTick(this.mangerUserList3);
		},
		async loadList() {
			this.tableLoading = true;
			const data = await mangerUserList3(this.form);
			this.list = data.filter(item => !item.deleted);
			this.tableLoading = false;
		},
		async mangerUserList3() {
			const selectListObj = {};
			this.selectListTem.forEach(item => {
				selectListObj[item.id] = true;
			});
			const repeat = [];
			const repeatID = [];
			this.list.forEach(item => {
				selectListObj[item.id] && repeat.push(item);
				selectListObj[item.id] && repeatID.push(item.id);
			});
			this.selectListTem = this.selectListTem.filter(item => !repeatID.includes(item.id));
			this.$nextTick(() => {
				repeat.forEach(item => {
					this.$refs.table.toggleRowSelection(item, true);
				});
			});
		},
		handleSelectionChange(val) {
			this.selectList = uniqBy([...this.selectListTem, ...val], 'id');
		},
		async search() {
			this.selectListTem = this.selectList;
			await this.loadList();
			this.mangerUserList3();
		},
		confirm() {
			this.tagtList = this.selectList;
			this.handleClose();
		},
		handleClose() {
			this.visible = false;
		},
		handleCloseTag(tag) {
			this.tagtList = this.tagtList.filter(item => item.id != tag.id);
		},
		getValue() {
			return this.tagtList.map(item => item.id);
		},
		selectable(row) {
			if (row.status == 1) {
				return false;
			}
			if (this.selectList.find(item => item.id == row.id)) {
				return true;
			}
			if (this.selectList.length >= this.info.content.receiver_limit) {
				return false;
			}
			return true;
		},
	},
};
</script>
<style lang="less" scoped>
/deep/ .el-table__header-wrapper .el-checkbox {
	display: none;
}
.add-staff {
	.content {
		padding: 24px 24px 60px 24px;
	}
	.searchBtn {
		width: 56px;
		background-color: #7052ff;
		color: #ffffff;
		font-size: 13px;
		border-top-left-radius: 2px;
		border-bottom-left-radius: 2px;
		position: absolute;
		right: 0;
		top: 0px;
		border: 1px solid #7052ff;
	}
	.footer {
		position: absolute;
		width: 100%;
		bottom: 0;
		padding: 10px;
		display: flex;
		justify-content: flex-end;
		border-top: 1px solid #f0f1f5;
		box-shadow: 0px -2px 10px 0px rgba(0, 0, 0, 0.1);
		z-index: 999;
	}
}
</style>
